import { render } from "./Chat.vue?vue&type=template&id=a66fde0e"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
script.render = render

export default script